<script setup lang="ts">

</script>

<template>
	<div class="flex flex-col">
		<div>
			<span class="font-league-gothic text-accent font-medium uppercase text-[2rem] xs:text-[2.25rem] lg:text-[1.875rem] xl:text-[2.75rem] 2xl:text-[3rem] tracking-normal block mb-2">
				Newsletter
			</span>
		</div>
		<p class="mb-4">Regelmäßig aktuelle Infos und Nachrichten direkt per Newsletter.</p>
		<NuxtLink :to="{ name: 'article-detail', params: { article_slug: 'newsletter'}}" no-prefetch class="flex group gap-1.5 mx-auto md:mx-0">
			<GsIcon name="prime:arrow-right" class="flex-none my-auto lg:mt-0.5 text-accent size-5 lg:size-8 group-hover:text-primary transiton duration-300 ease-in-out"></GsIcon>
			zur Anmeldung
		</NuxtLink>
	</div>
</template>
